module.exports = __webpack_public_path__ + "img/kkp-wh.1f819b36.svg";